import { transition } from '@helpers/animation';
import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import { buttonTheme } from '@stories/Components/Buttons/ButtonShared.styles';
import LinkButtonStyles from '@stories/Components/Buttons/LinkButton/LinkButton.styles';
import styled from 'styled-components';
const Container = styled.section `
  ${transition('max-height', 1)};

  max-height: 100vh;
  background-color: ${brand.white};
  position: relative;

  .theme-hh & {
    background-color: ${brand.grey};
  }

  .theme-rss & {
    background-color: ${brand.black};
  }

  &[data-cookie='true'] {
    max-height: 0;
  }

  .theme-hta & {
    ${() => LinkButtonStyles.Button} {
      ${buttonTheme({
    bgColor: brand.hta.green,
    borderColor: brand.hta.green,
    fgColor: brand.black,
})}

      &:focus,
      &:hover {
        ${buttonTheme({
    bgColor: brand.hta.greenLight,
    borderColor: brand.hta.greenLight,
    fgColor: brand.black,
})}
      }

      &:active {
        ${buttonTheme({
    bgColor: brand.hta.green,
    borderColor: brand.hta.green,
    fgColor: brand.black,
})}
      }
    }
  }
`;
const NotificationBar = styled.div `
  ${transition('opacity')};

  width: 100%;
  padding: 1px 0;

  ${Container}[data-cookie='true'] & {
    opacity: 0;
  }

  @media ${until(Device.TabletLarge)} {
    margin: 5px;
    width: calc(100% - 10px);
  }

  .theme-hh & {
    background-color: ${brand.grey};
  }
`;
const NotificationInner = styled.div `
  background-color: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  margin: 12px auto;
  max-width: 1100px;
  min-height: 68px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 5px 20px 4px rgba(0, 0, 0, 0.2);
  pointer-events: all;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-evenly;

  ${setCssVar('bgColor', brand.hta.greenDark)};
  ${setCssVar('fgColor', brand.white)};

  .theme-apl & {
    ${setCssVar('bgColor', brand.apl.green)};
    ${setCssVar('fgColor', brand.black)};

    ${LinkButtonStyles.Button} {
      background: ${brand.white};
      color: ${brand.black};
    }
  }

  .theme-hh & {
    ${setCssVar('bgColor', brand.hortHouse.green)};
    ${setCssVar('fgColor', brand.white)};

    ${LinkButtonStyles.Button} {
      background: ${brand.white};
      color: ${brand.grey};
    }
  }

  .theme-rss & {
    ${setCssVar('bgColor', brand.rss.greyLight)};
    ${setCssVar('fgColor', brand.white)};
  }
`;
const NotificationGrid = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${until(Device.TabletLarge)} {
    flex-direction: column;

    ${LinkButtonStyles.Button} {
      height: auto;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
`;
const NotificationTextArea = styled.div `
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  margin: auto;

  @media ${until(Device.TabletLarge)} {
    padding-bottom: 10px;
    padding-right: 35px;
  }

  span {
    @media ${until(Device.TabletLarge)} {
      display: block;
      margin: 0 auto;
    }
  }

  a {
    min-width: 160px;
  }

  @media ${until(Device.Tablet)} {
    flex-direction: column;
  }
`;
const NotificationIcon = styled.div ``;
const NotificationText = styled.p `
  text-align: left;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media ${until(Device.Tablet)} {
    text-align: center;
  }
`;
const NotificationCtaArea = styled.div `
  @media ${from(Device.TabletLarge)} {
    display: flex;
    align-items: center;
  }
`;
const NotificationClose = styled.button `
  background-color: transparent;
  border: none;
  color: ${brand.white};
  margin: 0 30px 0 40px;
  line-height: 0;

  @media ${until(Device.TabletLarge)} {
    position: absolute;
    right: 10px;
    top: 20px;
    margin: 0;
  }
`;
const Clover = styled.img `
  width: 100%;
  max-width: 30px;
  height: 25px;

  svg {
    width: 100%;
    height: 100%;
  }

  .theme-hh & {
    color: ${brand.grey};
  }
`;
const Close = styled(SvgClose) `
  height: 25px;

  @media ${until(Device.TabletLarge)} {
    height: 15px;
  }
  .theme-apl & {
    color: ${brand.black};
  }
`;
const NotificationBannerStyles = {
    Container,
    NotificationBar,
    NotificationClose,
    NotificationCtaArea,
    NotificationGrid,
    NotificationInner,
    NotificationIcon,
    NotificationText,
    NotificationTextArea,
    Close,
    Clover,
};
export default NotificationBannerStyles;
